import request from '@/utils/request'
/*71.获取混凝土产品列表*/
export function getLists() {
	return request({
		url: '/icps/system/sign/basics/namingRule/getLists',
		method: 'post',
	})
}
/*71.新增混凝土产品命名规则*/
export function namingRulesave(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/save',
		method: 'post',
		data
	})
}
/*排序*/
export function updateSortNum(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/updateSortNum',
		method: 'post',
		data
	})
}
/*删除*/
export function dateleNamingRule(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/dateleNamingRule',
		method: 'post',
		data
	})
}
/*76.获取所有的互斥数据*/
export function QueryRepels(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/QueryRepels',
		method: 'post',
		data
	})
}
/*76.77.删除混凝土产品互斥数据*/
export function deletesRepels(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/deletesRepels',
		method: 'post',
		data
	})
}
/*76.77.新增混凝土产品互斥*/
export function saveRepel(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/saveRepel',
		method: 'post',
		data
	})
}
/*分页获取混凝土产品价格列表*/
export function QueryMoneyPage(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/QueryMoneyPage',
		method: 'post',
		data
	})
}
/*.72.新增混凝土产品价格*/
export function saveMoney(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/saveMoney',
		method: 'post',
		data
	})
}
/*.74.删除混凝土产品价格*/
export function deletesMoney(data) {
	return request({
		url: '/icps/system/sign/basics/namingRule/deletesMoney',
		method: 'post',
		data
	})
}